// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"432":"1388f2dc","552":"2608c65b","817":"081e0f41","930":"80e40268","959":"51b4d4c8","962":"308d6507"}[chunkId] + ".chunk.js";
};